/* eslint-disable */
import mutations from './mutations'
import actions from './actions'

export default {
    state: {
    	employeeList: []
    },
    mutations,
    actions,
};
